import React, {
  createContext,
  FC,
  useContext,
  useEffect,
  useState,
} from "react";
import { useQuery, ApolloError } from "@apollo/client";
import queries from "../Shared/queries";
import { DPEmployeeProfile } from "Shared/types/EmployeeProfiles";
import { EmployeeProfileQuery, EmployeeProfileQueryVariables } from "generated/graphql";

type EmployeeProfileQueryData = {
  userDetails: DPEmployeeProfile | null;
  loading: boolean;
  error: ApolloError | undefined;
  refetchEmployeeProfile: () => void;
};

const initialEmployeePofileQueryState: EmployeeProfileQueryData = {
  userDetails: null,
  loading: true,
  error: undefined,
  refetchEmployeeProfile: () => {},
};

const EmployeProfileContext = createContext(initialEmployeePofileQueryState);

type Props = {
  id: string;
};

export const EmployeProfileQueryProvider: FC<Props> = ({ children, id }) => {
  const [userDetails, setUserDetails] = useState<DPEmployeeProfile | null>(null);
  const { data, loading, error, refetch } = useQuery<
    EmployeeProfileQuery,
    EmployeeProfileQueryVariables
  >(queries.GET_EMPLOYEE_PROFILE, {
    variables: {
      employeeProfileId: id,
    },
  });

  const refetchEmployeeProfile = () => {
    refetch();
  };

  useEffect(() => {
    if (!loading && data && data.employeeProfile) {
      setUserDetails(data.employeeProfile);
    }
  }, [data, loading, error]);

  return (
    <EmployeProfileContext.Provider
      value={{ userDetails, loading, error, refetchEmployeeProfile }}
    >
      {children}
    </EmployeProfileContext.Provider>
  );
};

export const useEmployeeProfileQuery = () => useContext(EmployeProfileContext);
